import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import {Location, MapLocation} from '../locations.types'
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import {faMapMarkerAlt} from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'

@Component({
  selector: 'cft-location-card',
  templateUrl: './location-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference "../../../../styles/theme.css";
    :host {
      @apply block rounded-3 shadow-1 hover:shadow-2;
    }
  `,
  standalone: false,
})
export class LocationCardComponent implements OnChanges {
  @Input() location!: Location
  @Input() googleMapsApiKey!: string
  @Input() zoom = 13
  @Input() defaultLocationLabel?: string
  @Input() contactDetailsHeading = 'Contact details'
  @Output() avatarClick = new EventEmitter()

  @ViewChild('actions') actionsElement!: ElementRef<HTMLDivElement>

  mapLocation!: MapLocation

  readonly locationIcon = faMapMarkerAlt
  readonly emailIcon = faEnvelope
  readonly phoneIcon = faPhone

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.location.currentValue) {
      this.mapLocation = new MapLocation(this.location, [], this.googleMapsApiKey)
      this.mapLocation.show()
    }
  }
}
